import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/default-credit-days', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/default-credit-days/${data.company_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  update
}
